webpackJsonp([103],{

/***/ 3015:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_platform_user_platform_user_api__ = __webpack_require__(259);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReviewPlanFormPage',
  data: function data() {
    return {
      formRules: {
        admin_id: [{ required: true, message: '请选择复核人', trigger: 'change' }],
        plan_date: [{ required: true, message: '请选择日期', trigger: 'change' }],
        review_target: [{
          validator: function validator(rule, value, callback) {
            var v = value === null || value === undefined || value === '' ? null : Number(value);
            if (v === null || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(v) || v < 0) {
              callback(new Error('请输入正确的目标单量（>=0）'));
              return;
            }
            callback();
          },
          trigger: 'blur'
        }]
      },
      form: {
        id: null,
        admin_id: null,
        plan_date: null,
        review_target: null
      }
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },

  methods: {
    queryPlatformUsers: function queryPlatformUsers(params) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__views_platform_user_platform_user_api__["getPlatformUsersIndex"])(params || {}).then(function (res) {
        var body = res && res.data;
        var list = [];
        if (body && body.detail && Array.isArray(body.detail.data)) {
          list = body.detail.data;
        } else if (body && Array.isArray(body.data)) {
          list = body.data;
        }
        return { data: { data: list } };
      });
    },
    findPlatformUser: function findPlatformUser(params) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__views_platform_user_platform_user_api__["getPlatformUsersDetail"])(params || {}).then(function (res) {
        var body = res && res.data;
        var item = body;
        if (body && body.detail) {
          var candidate = body.detail;
          // 有的接口 detail 在内，有的接口可能直接在根层携带字段
          item = candidate && (candidate.id != null || candidate.name != null) ? candidate : body;
        }
        return { data: item };
      });
    },
    onLoad: function onLoad() {
      var _this = this;

      var id = this.$route.params && this.$route.params.id ? this.$route.params.id : null;
      if (!id) return;

      this.form.id = id;
      request.page('getReviewPlan', { id: id }).then(function (_ref) {
        var data = _ref.data;

        // 后端字段：admin_id / plan_date / review_target
        filter.setLoop(_this.form, data);
        _this.form.admin_id = data.admin_id != null ? String(data.admin_id) : null;
        _this.form.review_target = data.review_target != null ? Number(data.review_target) : null;
      });
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.onLoad();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) return;

        var payload = {
          admin_id: parseInt(_this2.form.admin_id, 10),
          plan_date: _this2.form.plan_date,
          review_target: parseInt(_this2.form.review_target, 10)
        };

        if (_this2.form.id) {
          request.common('updateReviewPlan', { id: _this2.form.id, review_target: payload.review_target }).then(function () {
            _this2.$message.success('保存成功');
            _this2.$router.push({ path: '/task/review-plan/table' });
          });
        } else {
          request.common('createReviewPlan', payload).then(function () {
            _this2.$message.success('创建成功');
            _this2.$router.push({ path: '/task/review-plan/table' });
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewPlanFormPage_vue__ = __webpack_require__(3015);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bae70be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewPlanFormPage_vue__ = __webpack_require__(5559);
function injectStyle (ssrContext) {
  __webpack_require__(5557)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewPlanFormPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bae70be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewPlanFormPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5557:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5558);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("169ff72a", content, true, {});

/***/ }),

/***/ 5558:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".form-content-half .el-form-item__content{max-width:50%}.form-panel{margin:20px 0 0;width:100%;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", "", {"version":3,"sources":["/workspace/src/views/task/pages/ReviewPlanFormPage.vue"],"names":[],"mappings":"AACA,0CAA0C,aAAa,CACtD,AACD,YAAY,gBAAgB,WAAW,qBAAqB,kBAAkB,wBAAwB,CACrG","file":"ReviewPlanFormPage.vue","sourcesContent":["\n.form-content-half .el-form-item__content{max-width:50%\n}\n.form-panel{margin:20px 0 0;width:100%;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("任务管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/task/review-plan/table' }}},[_vm._v("复核目标")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.form.id ? '修改复核目标' : '添加复核目标'))]),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form-content-half",attrs:{"model":_vm.form,"rules":_vm.formRules,"label-width":"140px","size":"medium"}},[_c('el-form-item',{attrs:{"label":"复核人","prop":"admin_id"}},[_c('remote-select',{attrs:{"placeholder":"请输入用户名称搜索","id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","query-request":_vm.queryPlatformUsers,"find-request":_vm.findPlatformUser,"disabled":!!_vm.form.id,"clearable":""},model:{value:(_vm.form.admin_id),callback:function ($$v) {_vm.$set(_vm.form, "admin_id", $$v)},expression:"form.admin_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"日期","prop":"plan_date"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd","type":"date","placeholder":"请选择","disabled":!!_vm.form.id,"clearable":"","align":"right"},model:{value:(_vm.form.plan_date),callback:function ($$v) {_vm.$set(_vm.form, "plan_date", $$v)},expression:"form.plan_date"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"目标数","prop":"review_target"}},[_c('el-input',{staticClass:"width-max",attrs:{"placeholder":"请输入目标单量","type":"number","min":0},model:{value:(_vm.form.review_target),callback:function ($$v) {_vm.$set(_vm.form, "review_target", $$v)},expression:"form.review_target"}})],1),_vm._v(" "),_c('el-row',{staticClass:"form-panel"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("保存")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/review-plan-form-create.c81ab39ffcd26a83caf0.js